import _get from "lodash/get.js";
import { nullsToUndefined } from "../../../../null.js";
export const productCardTransportConverter = ({ searcher , descriptions =[
    ''
] , title ='' , subtitle ='' , link ={
    href: ''
} , departureContent , returnContent , tooltip , imgSrc ='' , ...item }, config)=>({
        config: {
            ...config,
            literals: {
                ...config?.literals,
                fromCaption: item.priceLabel ?? '',
                summary: config?.literals?.summaryLabel,
                moreInfo: config?.literals?.infoLabel,
                modalTitle: item?.modal?.title
            },
            // SEARCHER FLIGHT
            hasModal: true,
            endpoint: 'test',
            typeCard: config?.typeCard
        },
        searcher,
        tooltip,
        descriptions,
        link,
        offerNote: item?.modal?.footer,
        image: {
            src: imgSrc,
            alt: item.imgAlt,
            alternative: item.imgAlternative
        },
        title,
        subtitle,
        departureContent,
        returnContent,
        price: {
            value: item.price ? Math.floor(item.price) : undefined,
            caption: true,
            from: !!item.priceLabel
        },
        moreInfo: nullsToUndefined(item.info),
        companies: [
            {
                src: item.logos?.logoSrc ?? '',
                alternative: item.logos?.logoAlternative ?? '',
                alt: item.logos?.logoAlt ?? '',
                title: item.logos?.logoTitle ?? ''
            }
        ].filter((_)=>!!_.src),
        expandedInfo: [
            {
                arrival: {
                    origin: {
                        city: _get(searcher, 'origin.value.text', ''),
                        date: _get(searcher, 'calendar.startDate', ''),
                        hour: ''
                    },
                    destination: {
                        city: _get(searcher, 'destination.value.text', ''),
                        date: _get(searcher, 'calendar.endDate', ''),
                        hour: ''
                    },
                    info: {
                        logo: ''
                    }
                }
            }
        ],
        tag: item.tag
    });

//# sourceMappingURL=index.js.map